<template>
    <div>
        <div class="row">
            <div class="col-md-6 ">
                <div v-if="crawl_completed" class="panel panel-default">
                    <div class="panel-heading">Distribution of Folder1</div>
                    <div class="panel-body">
                        <SingleFieldBarChart field_name="folder1" v-bind:extent_id="extent_id" />
                    </div>
                </div>
                <div v-else class="panel panel-default">
                    <div class="panel-heading">Crawl Progress</div>
                    <div v-if="job_chain_id" class="panel-body">
                        <progress-display v-bind:job_chain_id="job_chain_id" @status_change="handleProgressStatusChange"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Start Assigning</div>
                    <div class="panel-body">
                        <percentage-assign :crawl_completed="crawl_completed" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    export default {
        props: ['session_job_chain_id'],
        data() {
            return {
                extent_id: null,
                crawl_completed: false,
                stored_job_chain_id: null
            }
        },
        computed: {
            job_chain_id: function () {
                if (this.session_job_chain_id) {
                    return this.session_job_chain_id
                } else {
                    return this.stored_job_chain_id
                }
            }
        },
        mounted() {
            axios.get('/api/free_extent')
                .then(response => {
                    console.log("extent id:")
                    console.log(response.data.extent_id)
                    this.extent_id = response.data.extent_id
                })
                .catch(error => {
                    console.log('oops getting extent for the user')
                })
            axios.get('/api/free_counts')
                .then(response => {
                    console.log('this is the data we get from /api/get_counts in work component')
                    console.log(response.data)
                    const count = response.data.find((count) => {
                        return count.count_type ===  'processed_asset_count';
                    });

                    if(count) {
                       if(count.count > 0) this.crawl_completed = true
                    }
                })
                .catch(error => {
                    console.log('oops getting the counts')
                })
            axios.get('/progress/latest')
                .then(response => {
                    console.log('this is the latest jobchain')
                    console.log(this.data)
                    this.stored_job_chain_id = response.data.id
                })
                .catch(error => {
                    console.log('oops getting previous settings for the user')
                })
        },
        methods: {
            handleProgressStatusChange(status) {
                console.log(status)
                if (status === "completed") {
                    this.crawl_completed = true
                    axios.post('/api/free_count', {
                    }).then(response => {
                        console.log(response)
                    }).catch(error => {
                        console.log('oops saving count')
                        console.log(error.response)
                    })
                }
            }
        }
    }

</script>